import { z } from 'zod'

/**
 * Identifiant renvoyé par l'API (UUID, clé import, etc.).
 * Le client ne doit pas imposer le format RFC 4122 : Zod peut être plus strict que le backend
 * ou que les données existantes (ex. identifiants sans tirets, legacy).
 */
export const apiIdSchema = z.coerce.string().min(1)
